@if (!futureBenefitsDisclaimer) {
  <div class="mb-3 message-card">
    <mwp-text-translate text="Please read the disclaimer below and check the box at the bottom of the page indicating your agreement. Click Confirm to continue." jsonKey="futureBenefitsDisclaimer7" />
  </div>
}
<div class="content-container">
  <div class="content">
    @if (futureBenefitsDisclaimer) {
      <mwp-text-translate text="You have completed the enrollment process for:" jsonKey="futureBenefitsDisclaimer1" />
      <br>
      <span>{{futureBenefitsDisclaimer.benefit1}}
        <mwp-text-translate text="effective" jsonKey="futureBenefitsDisclaimer2" />
        {{futureBenefitsDisclaimer.benefit1ActivationDate}}
        <mwp-text-translate text="and terminating" jsonKey="futureBenefitsDisclaimer3" />
        {{futureBenefitsDisclaimer.benefit1TerminationDate}}
      </span>
      <br>
      <br>
      <mwp-text-translate text="You will now begin the enrollment process for:" jsonKey="futureBenefitsDisclaimer4" />
      <br>
      <span>
          {{futureBenefitsDisclaimer.benefit2}}
        <mwp-text-translate text="effective" jsonKey="futureBenefitsDisclaimer2" />
        {{futureBenefitsDisclaimer.benefit2ActivationDate}}
      </span>
      <br>
      <br>
      @if (!futureBenefitsDisclaimer.isOpenEnrollment) {
        <span>
        <mwp-text-translate text="Any members you selected for coverage on the previous benefit will automatically be enrolled in this benefit." jsonKey="futureBenefitsDisclaimer5" />
        <br>
        <br>
        </span>
      }
      <mwp-text-translate text="Click Confirm to Continue" jsonKey="futureBenefitsDisclaimer6" />
    }
    @if (!futureBenefitsDisclaimer) {
      <div class="mb-3" [innerHTML]="disclaimer.disclaimer | pipeSafeHTML"></div>
      <div>
        <mat-checkbox [checked]="isAgree" (change)="toggleAgreement()">
          <mwp-text-translate text="By checking this box you certify that you have read and agree to the above terms and conditions." jsonKey="futureBenefitsDisclaimerCheckBox" />
        </mat-checkbox>
      </div>
    }
  </div>
  <div class="footer">
    <mwp-benefit-enrollment-wizard-control [isContinueDisabled]="!isAgree" (emitComplete)="submitAgreemt()"></mwp-benefit-enrollment-wizard-control>
  </div>
</div>
                